import ToggleContentToModal from './modules/toggle-content-to-modal';
import { capitalize } from './utils/formatting-utils';
import {
  dispatchSiteEvent,
  siteEventNames,
} from './events/site-events';
import { scrollToElement } from './utils/scrolling-utils';

Vue.component('swatchcard', {
  props: ['swatch', 'localSwatchbook', 'accountSwatchData', 'selectedTab'],
  data: function() {
    return {
      $btn: null,
      previousElementInFocus: null,
    }
  },
  methods: {
    swatchButtonHandler: function(event) {
      this.$btn = $(event.target).closest('button');
      if (this.isInLocalSwatchbook('sw-' + this.swatch.Id)) {
        this.removeSwatch();
      } else {
        this.addSwatch();
      }
    },
    onSwatchbookUpdated: function(action) {
      var eventName = '';
      if (action === 'add') {
        eventName = siteEventNames.ADD_SWATCH;
      } else if (action === 'remove') {
        eventName = siteEventNames.REMOVE_SWATCH;
      } else {
        return;
      }
      dispatchSiteEvent(eventName, {
        // <ecommerce_begin>
        item_category: 'Swatches',
        item_category2: capitalize(this.selectedTab),
        item_id: this.swatch.Id,
        item_name: this.swatch.JSSafeColorName,
        price: 0,
        quantity: 1,
        // </ecommerce_end>
        swatch_category: capitalize(this.selectedTab),
        swatch_collection: this.swatch.JSSafeCollectionName,
        swatch_color: this.swatch.JSSafeColorName,
        swatch_id: this.swatch.Id,
        swatch_number: this.swatch.ColorNumber,
        swatch_product: this.swatch.JSSafeStyleTitle,
        swatch_type: this.swatch.JSSafeSwatchCategoryName,
      });
    },
    addSwatch: function() {
      var that = this;
      var id = 'sw-' + this.swatch.Id;
      if (window.isAuthenticated) {
        this.$btn.addClass('btn--disabled');
        window.StorageActions.saveItemToAccount('swatch', this.getSwatchAccountOptions(), function(data) {
          that.$btn.removeClass('btn--disabled');
          if (data.success) {
            that.localSwatchbook.push(id);
            // Update accountSwatchData
            that.$emit('update-account-swatches');
            that.onSwatchbookUpdated('add');
          }
        });
      } else {
        this.localSwatchbook.push(id);
        window.swatchbook.saveItem(this.getLocalStorageOptions());
        this.onSwatchbookUpdated('add');
      }
    },
    removeSwatch: function() {
      var that = this;
      var id = 'sw-' + this.swatch.Id;
      if (window.isAuthenticated) {
        // Get asset id
        var digitalSwatchId;
        for (var i = 0; i < this.accountSwatchData.length; i++) {
          if (id === 'sw-' + this.accountSwatchData[i]['swatch-id'].toString()) {
            digitalSwatchId = this.accountSwatchData[i]['digital-swatch-id']
          }
        }
        if (!digitalSwatchId) {
          console.warn('swatches.js, no digital-swatch-id found, cannot remove.');
          return;
        }
        this.$btn.addClass('btn--disabled');
        window.StorageActions.removeItemFromAccount('swatch', digitalSwatchId, function(data) {
          that.$btn.removeClass('btn--disabled');
          if (data.success) {
            that.localSwatchbook.splice(that.localSwatchbook.indexOf(id), 1);
            // Update accountSwatchData
            that.$emit('update-account-swatches');
            that.onSwatchbookUpdated('remove');
          }
        });
      } else {
        window.swatchbook.removeItem('swatch', id);
        this.localSwatchbook.splice(this.localSwatchbook.indexOf(id), 1);
        this.onSwatchbookUpdated('remove');
      }
    },
    isInLocalSwatchbook: function(id) {
      if (this.localSwatchbook.indexOf(id) !== -1) {
        return true;
      }
      return false;
    },
    getSwatchAccountOptions: function() {
      return {
        productLineCode: this.swatch.SwatchProductLineCode,
        colorNumber: this.swatch.ColorNumber,
        swatchId: this.swatch.Id.toString()
      };
    },
    getLocalStorageOptions: function() {
      return {
        type: 'swatch',
        id: 'sw-' + this.swatch.Id,
        imageUrl: window.swatchImagePath + '/GraberBlindsImages/SwatchImages/' + this.swatch.LargeImagePath,
        description: '',
        page: 'Order Free Swatches',
        dateSaved: new Date(),
        name: this.swatch.JSSafeColorName,
        category: capitalize(this.selectedTab),
        colorNumber: this.swatch.ColorNumber,
        collection: this.swatch.JSSafeCollectionName,
        colorName: this.swatch.JSSafeColorName,
        styleId: this.swatch.StyleId,
        swatchId: this.swatch.Id,
        swatchCatId: this.swatch.SwatchCategoryId,
        swatchCatName: this.swatch.JSSafeSwatchCategoryName,
        newSwatch: this.swatch.NewSwatch,
        productLine: this.swatch.JSSafeProductLineTitle,
        productLineCode: this.swatch.SwatchProductLineCode,
        assetId: this.swatch.AssetId
      };
    },
    openSwatchModal: function(src) {
      this.previousElementInFocus = document.activeElement;
      var gallery = document.getElementById('swatch-modal');
      lightGallery(gallery, {
        dynamic: true,
        dynamicEl: [{
          'src': src,
        }],
        download: false,
        share: false,
        startClass: 'lg-start-fade',
        speed: 100,
        addClass: 'lg--swatch',
        width: '300px',
        height: '300px',
        counter: false
      });
      gallery.addEventListener('onCloseAfter', this.handleCloseGallery);
    },
    showSwatchMenu: function(event) {
      $(event.target).closest('.o-swatchCard__image').addClass('show-menu');
    },
    hideSwatchMenu: function(event) {
      $(event.target).closest('.o-swatchCard__image').removeClass('show-menu');
    },
    handleCloseGallery: function(event) {
      event.target.removeEventListener('onCloseAfter', this.handleCloseGallery);
      window.lgData[event.target.getAttribute('lg-uid')].destroy(true);
      this.previousElementInFocus.focus();
    }
  }
});

var vm = new Vue({
  el: '#swatches-app',
  data: {
    isAuthenticated: window.isAuthenticated,
    initialLineId: 200,
    initialShadesLineId: 200,
    initialBlindsLineId: 332,
    initialDraperyLineId: 1365,
    allSwatches: [],
    availableColorRanges: [],
    productFilterOpen: true,
    collectionFilterOpen: true,
    colorFilterOpen: true,
    catalogUrl: window.swatchCatalogPath,
    productLines: [],
    collections: [],
    colorRanges: [],
    linesToLoad: [],
    linesLoaded: [],
    productStyles: [],
    productLineLoadItr: 0,
    checkedCollections: [],
    checkedColorRanges: [],
    checkedProductStyles: [],
    showAllCollections: false,
    numSwatchesToDisplay: 48,
    selectedTab: 'shades',
    loadedFromParam: false,
    loadedFromParamLineName: '',
    localSwatchbook: [],
    requesting: false,
    currentLineOpen: null,
    visualizerModelId: '',
    visualizerProgamFamilyName: '',
    accountSwatchData: [],
    xhrRequest: null,
    loadedData: {
      shades: {
        loaded: false,
        swatches: [],
        productLines: [],
        collections: [],
        colorRanges: []
      },
      blinds: {
        loaded: false,
        swatches: [],
        productLines: [],
        collections: [],
        colorRanges: []
      },
      drapery: {
        loaded: false,
        swatches: [],
        productLines: [],
        collections: [],
        colorRanges: []
      },
    }
  },
  computed: {
    filteredByProductStyleSwatches: function () {
      var arr = this.computedProductStyles;
      var tempArr = [];
      if (arr.length === 0 && this.currentLineOpen !== null) {
        // *NEW* Auto-populate arr w/ currentLine options
        // to "show" all swatches from this product line w/o checking boxes
        // Once box is checked, use existing logic
        if (this.currentLineOpen.options) {
          for (var j = 0; j < this.currentLineOpen.options.length; j++) {
            tempArr.push(this.currentLineOpen.name + ' ' + this.currentLineOpen.options[j]);
          }
        }
        arr = tempArr;
      }
      // Filter by Product Styles
      var s = '';
      for (var i = 0; i < arr.length; i++) {
        if (i === 0) {
          s = s + '^';
        } else {
          s = s + '|^';
        }
        s = s + arr[i];
        s = s + '$';
      }
      var regex = new RegExp(s, 'i');
      var swatches = this.allSwatches.filter(function(swatch){
        var tested = regex.test(swatch.JSSafeProductLineTitle + ' ' + swatch.JSSafeSwatchCategoryName);
        return tested
      });
      return swatches;
    },
    filteredByCollectionAndColorsSwatches: function () {
      var that = this;
      var s = '';
      for (var i = 0; i < this.computedCollections.length; i++) {
        if (i === 0) {
          s = s + '^';
        } else {
          s = s + '|^';
        }
        s = s + this.computedCollections[i].replace(/([^a-z0-9]+)/gi, ' ');
        s = s + '$';
      }
      var regex = new RegExp( s, "i" );
      var swatches = this.filteredByProductStyleSwatches.filter(function(swatch){
        var tested;
        if (swatch.JSSafeCollectionName === "") { // if swatch has no collection
          if (that.collections.length !== that.computedCollections.length) { // if collections are checked
            tested = false;
          } else {
            tested = true;
          }
        } else {
          tested = regex.test(swatch.JSSafeCollectionName.replace(/([^a-z0-9]+)/gi, ' '));
        }
        return tested
      });

      var colorSwatches = swatches.filter(function(swatch){
        var test;
        if (that.colorRanges.length === that.computedColorRanges.length) { // if no color ranges are checked
          test = true;
        } else {
          var match = false;
          if (swatch.SwatchColorRangeIds !== null) {
            for (var n = 0; n < swatch.SwatchColorRangeIds.length; n++) {
              if (that.computedColorRanges.indexOf(parseInt(swatch.SwatchColorRangeIds[n])) !== -1) {
                match = true;
              }
            }
          }
          if (match) {
            test = true;
          } else {
            test = false;
          }
        }
        return test
      });

      if (swatches)
      return colorSwatches
    },
    computedColorRanges: function () {
      if (this.checkedColorRanges.length === 0) {
        var gah = [];
        for (var i = 0; i < this.colorRanges.length; i++) {
          gah.push(this.colorRanges[i].num);
        }
        return gah;
      } else {
        return this.checkedColorRanges;
      }
    },
    computedCollections: function () { // Logic used for filtering swatches if no collections checked
      if (this.checkedCollections.length === 0) {
        return this.collections;
      } else {
        return this.checkedCollections;
      }
    },
    displayedCollections: function () { // Logic for what collections to render in filter list
      var checkedArr = this.checkedProductStyles;
      var tempArr = [];
      if (checkedArr.length === 0 && this.currentLineOpen !== null) {
        // *NEW* Auto-populate collections based on currentLine options
        // to "show" all swatches from this product line w/o checking boxes
        // Once box is checked, use existing logic
        if (this.currentLineOpen.options) {
          for (var j = 0; j < this.currentLineOpen.options.length; j++) {
            tempArr.push(this.currentLineOpen.name + ' ' + this.currentLineOpen.options[j]);
          }
          checkedArr = tempArr;
        }
      }
      if (checkedArr.length === 0) { // If there are no product styles checked
        return this.collections; // Then return all collections
      } else { // Otherwise return all collections associated with checked product styles
        var arr = [];
        for (var i = 0; i < this.filteredByProductStyleSwatches.length; i++) {
          if (arr.indexOf(this.filteredByProductStyleSwatches[i].JSSafeCollectionName) == -1 && this.filteredByProductStyleSwatches[i].JSSafeCollectionName !== '') {
            arr.push(this.filteredByProductStyleSwatches[i].JSSafeCollectionName);
          }
        }
        return arr.sort();
      }
    },
    computedProductStyles: function () {
      if (this.checkedProductStyles.length === 0) {
        return this.productStyles;
      } else {
        return this.checkedProductStyles;
      }
    },
    truncatedCollections: function () {
      var sortedDisplayedCollections = this.displayedCollections;
      sortedDisplayedCollections.sort();
      if (this.showAllCollections) {
        return sortedDisplayedCollections;
      } else {
        return sortedDisplayedCollections.slice(0, 8);
      }
    },
    truncatedColorRanges: function() {
     if (this.checkedColorRanges.length > 0) {
      return this.availableColorRanges;
     }
      var that = this;
      this.availableColorRanges = [];
      that.colorRanges.forEach((colorRange) => {
        let match = -1;
        that.filteredByCollectionAndColorsSwatches.forEach((swatch) => {
          if (match === -1 && swatch.SwatchColorRangeList) {
            match = swatch.SwatchColorRangeList.findIndex((listItem) => listItem.Id === colorRange.num);
          }
        });
        if (match > -1) {
          this.availableColorRanges.push(colorRange);
        }
      });
      return this.availableColorRanges;
    },
    truncatedSwatches: function () {
      return this.filteredByCollectionAndColorsSwatches.slice(0, this.numSwatchesToDisplay);
    }
  },
  methods: {
    clearFilters: function () {
      this.checkedProductStyles = [];
      this.checkedCollections = [];
      this.checkedColorRanges = [];
      this.resetCurrentLineOpen();
      this.showAllCollections =true;
    },
    clearEverything: function () {
      this.xhrRequest.abort();
      this.allSwatches = [];
      this.availableColorRanges = [];
      this.productLines = [];
      this.collections = [];
      this.colorRanges = [];
      this.linesToLoad = [];
      this.linesLoaded = [];
      this.productStyles = [];
      this.productLineLoadItr = 0;
      this.clearFilters();
      this.requesting = false;
    },
    resetCurrentLineOpen: function() {
      if (this.currentLineOpen) {
        this.currentLineOpen.filterOpen = false;
        this.currentLineOpen = null;
      }
    },
    getParameterByName: function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    getProductNameById: function(id, arr) {
      var mergedArr = [];
      for (var i = 0; i < arr.length; i++) {
        mergedArr = mergedArr.concat(arr[i]);
      }
      // Need to concatenate all arrays?
      for (i = 0; i < mergedArr.length; i++) {
        if (mergedArr[i].Id === id) {
          return mergedArr[i].Name;
        }
      }
      return null;
    },
    getCatalogData: function (category, successCallback) {
      // If category has been changed before catalogData
      // request has finished, abort the XHR request
      var that = this;
      this.xhrRequest = new XMLHttpRequest();
      var request = this.xhrRequest;
      var requestURL = that.catalogUrl + category;
      request.open('GET', requestURL, true);
      this.requesting = true;
      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          var data = JSON.parse(request.responseText);
          if (successCallback) {
            successCallback(data);
          }
        }
      };
      request.onerror = function () {
        console.warn('Connection error loading ' + requestURL);
        that.requesting = false;
      };
      request.send();
    },
    getHashedCase: function (value) {
      if (!value) return ''
      return value.toLowerCase().replace(/[\s]+/g, '-').replace(/-&/g, '');
    },
    getCategoryIndex: function(productLines, categoryName) {
      for (var i = 0; i < productLines.length; i++) {
        var productLine = productLines[i]
        for (var j = 0; j < productLine.length; j++) {
          if (productLine[j].BlindTypeDescription.toLowerCase() === categoryName) {
            return i;
          }
        }
      }
      return -1;
    },
    overrideNaturalDrapesProps: function (data) {
      for (var i = 0; i < data.ProductLines.length; i++) {
        var productLine = data.ProductLines[i]
        for (var j = 0; j < productLine.length; j++) {
          if (productLine[j].Name === 'Natural Drapes') {
            productLine[j].BlindTypeCode = 'D';
            productLine[j].BlindTypeDescription = 'Drapery';
            // Remove from Shades index
            var naturalDrapesIndex = productLine.splice(j, 1);
            // Move to Drapery
            var draperyIndex = this.getCategoryIndex(data.ProductLines, 'drapery');
            if (draperyIndex !== -1) {
              data.ProductLines[draperyIndex].push(naturalDrapesIndex[0]);
              return data;
            }
          }
        }
      }
      return data;
    },
    onCategoryLoadComplete: function () {
      // If we have loaded all of the data, mark that category as
      // loaded and copy all of the data to the main data object
      switch (this.selectedTab) {
        case 'shades':
          this.loadedData.shades.loaded = true;
          this.loadedData.shades.swatches = this.allSwatches;
          this.loadedData.shades.productLines = this.productLines;
          this.loadedData.shades.collections = this.collections;
          this.loadedData.shades.colorRanges = this.colorRanges;
          break;
        case 'blinds':
          this.loadedData.blinds.loaded = true;
          this.loadedData.blinds.swatches = this.allSwatches;
          this.loadedData.blinds.productLines = this.productLines;
          this.loadedData.blinds.collections = this.collections;
          this.loadedData.blinds.colorRanges = this.colorRanges;
          break;
        case 'drapery':
          this.loadedData.drapery.loaded = true;
          this.loadedData.drapery.swatches = this.allSwatches;
          this.loadedData.drapery.productLines = this.productLines;
          this.loadedData.drapery.collections = this.collections;
          this.loadedData.drapery.colorRanges = this.colorRanges;
          break;
      }
      this.requesting = false;
    },
    removeProductLineById: function (id) {
      this.productLines = this.productLines.filter((line) => {
        return line.id !== id;
      });
    },
    onCatalogDataComplete: function (data) {
      // Override BlindTypeDescription and BlindTypeCode for Natural Drapes (HACK!)
      data = this.overrideNaturalDrapesProps(data);
      // If length of Swatches array is 0, then remove it from product from productLines array
      var isSwatchesEmpty = data.Swatches.length === 0;
      // Is line already loaded?
      var isLineLoaded = this.linesLoaded.indexOf(data.SelectedProductId) !== -1;
      // Get product line category name
      var blindTypeDescription = data.SelectedProductLine.BlindTypeDescription.toLowerCase();
      // When loading page w/ url param that is just a category number,
      // need to find what the category is so we can highlight correct tab
      if (this.selectedTab === '') {
        this.selectedTab = blindTypeDescription;
      }
      if (blindTypeDescription !== this.selectedTab) {
          console.warn(`${blindTypeDescription} is not selected tab`);
          this.requesting = false;
          return;
      }
      if (isLineLoaded || isSwatchesEmpty) {
        this.productLineLoadItr++;
        this.requesting = false;
        if (isSwatchesEmpty) {
          this.removeProductLineById(data.SelectedProductId);
        }
        if (this.productLineLoadItr === this.linesToLoad.length) {
          this.onCategoryLoadComplete();
        } else {
          this.getCatalogData(this.linesToLoad[this.productLineLoadItr], this.onCatalogDataComplete);
        }
        return;
      }
      // If initial run, set the tab and grab all the product lines
      if (this.productLines.length === 0) {
        this.linesLoaded = [];
        // Find product line index from blindTypeDescription
        var productLinesIndex = this.getCategoryIndex(data.ProductLines, blindTypeDescription);
        if (productLinesIndex === -1) {
          console.warn(`Product line for ${blindTypeDescription} not found`);
          this.requesting = false;
          return
        }
        // Get the name of the product line if loaded from a param number
        if (this.loadedFromParam) {
          this.loadedFromParamLineName = data.SelectedProductLine.Name;
        }
        // For all the product lines, grab the product line info and
        // add it to the product lines array.
        for (var i = 0; i < data.ProductLines[productLinesIndex].length; i++) {
          var name = data.ProductLines[productLinesIndex][i].Name;
          var line = {};
          line.category = data.ProductLines[productLinesIndex][i].BlindTypeDescription;
          line.name = name;
          line.id = data.ProductLines[productLinesIndex][i].Id;
          line.filterOpen = this.loadedFromParamLineName === name;
          this.productLines.push(line);
          if (line.id !== this.initialLineId) {
            this.linesToLoad.push(line.id);
          }
        }
      } else {
        // Not the first line loaded, increment load counter
        this.productLineLoadItr++;
      }
      this.linesLoaded.push(data.SelectedProductId);
      // Add the swatches to swatch array (and other things lol)
      // Load in product visualizer url params, then add swatches to page
      var prodName = this.getProductNameById(data.SelectedProductId, data.ProductLines);
      var that = this;
      window.swatchbook.getSwatchProductUrlParams(prodName, function(visualizerUrlParams) {
        that.addSwatchesToSwatchArray(data, visualizerUrlParams, blindTypeDescription);
      });
      // If we have not loaded all the lines to load yet,
      // load the next line in the array of lines to load
      if (this.productLineLoadItr === this.linesToLoad.length) {
        this.onCategoryLoadComplete();
      } else {
        this.getCatalogData(this.linesToLoad[this.productLineLoadItr], this.onCatalogDataComplete);
      }
    },
    addSwatchesToSwatchArray: function (data, visualizerUrlParams, blindTypeDescription) {
      for (var i = 0; i < data.Swatches.length; i++) {
        if (this.selectedTab !== blindTypeDescription) {
          return;
        }
        data.Swatches[i].visualizerModelId = visualizerUrlParams.visualizerModelId;
        data.Swatches[i].visualizerProgamFamilyName = visualizerUrlParams.visualizerProgamFamilyName;
        if (visualizerUrlParams.visualizerModelId !== null && visualizerUrlParams.visualizerProgamFamilyName !== null) {
          data.Swatches[i].isProductAvailableInVisualizer = true;
        } else {
          data.Swatches[i].isProductAvailableInVisualizer = false;
        }
        // Add to array
        this.allSwatches.push(data.Swatches[i]);

        var collection = data.Swatches[i].JSSafeCollectionName;
        if (this.collections.indexOf(collection) == -1 && collection !== '') {
          this.collections.push(collection);
        }
      }
      var ranges = data.ColorRanges;
      var cr = {};
      for (var i = 0; i < ranges.length; i++) {
        if (this.colorRanges.length === 0) {
          cr = {};
          cr.title = ranges[i].Title;
          cr.hex = this.getHashedCase(cr.title); // ranges[i].CssColor;
          cr.num = ranges[i].Id;
          this.colorRanges.push(cr);
        } else {
          var match = false;
          for (var q = 0; q < this.colorRanges.length; q++) {
            if (this.colorRanges[q].title === ranges[i].Title) {
              match = true;
            }
          }
          if (!match) {
              cr = {};
              cr.title = ranges[i].Title;
              cr.hex = this.getHashedCase(cr.title); // ranges[i].CssColor;
              cr.num = ranges[i].Id;
              this.colorRanges.push(cr);
          }
        }
      }

      var optionsArray = [];
      var productLineId = data.SelectedProductId;
      for (var i = 0; i < data.SwatchGrouping.Styles.length; i++) {
        for (var j = 0; j < data.SwatchGrouping.Styles[i].Categories.length; j++) {
          var cat = data.SwatchGrouping.Styles[i].Categories[j].JSSafeSwatchCategoryName;
          if (optionsArray.indexOf(cat) == -1) {
            optionsArray.push(cat);
            if (this.loadedFromParam && this.loadedFromParamLineName === data.SelectedProductLine.Name) {
              this.checkedProductStyles.push(this.loadedFromParamLineName + ' ' + cat);
            }
          }
        }
      }

      for (var i = 0; i < this.productLines.length; i++) {
        if (this.productLines[i].id === productLineId) {
          this.productLines[i].options = optionsArray;
        }
      }

    },
    removeURLParam: function() {
      window.history.replaceState(null, null, window.location.pathname);
    },
    changeSelectedTab: function(tab) {
      if (tab === this.selectedTab) {
        return
      }
      this.removeURLParam();
      this.clearEverything();
      this.resetSwatchesScroll();
      var selectedTabsLoadedData = {};
      // Setup variables based on selected tab
      switch (tab) {
        case 'shades':
          this.selectedTab = 'shades';
          this.initialLineId = this.initialShadesLineId;
          selectedTabsLoadedData = this.loadedData.shades;
          break;
        case 'blinds':
          this.selectedTab = 'blinds';
          this.initialLineId = this.initialBlindsLineId;
          selectedTabsLoadedData = this.loadedData.blinds;
          break;
        case 'drapery':
          this.selectedTab = 'drapery';
          this.initialLineId = this.initialDraperyLineId;
          selectedTabsLoadedData = this.loadedData.drapery;
      }
      // Tab is changed so so this cant be true anymore
      this.loadedFromParam = false;
      // If all swatches have loaded for the selected tab, populate arrays
      if (selectedTabsLoadedData.loaded) {
        this.allSwatches = selectedTabsLoadedData.swatches;
        this.productLines = selectedTabsLoadedData.productLines;
        this.collections = selectedTabsLoadedData.collections;
        this.colorRanges = selectedTabsLoadedData.colorRanges;
      } else {
        // Continue loading swatch data
        this.getCatalogData(this.initialLineId, this.onCatalogDataComplete);
      }
    },
    getSwatchesInSwatchbook: function() {
      if (window.useLocalStorage || !window.isAuthenticated) {
        var items = swatchbook.data.items;
        for (var i = 0; i < items.length; i++) {
          if (items[i].type === 'swatch') {
            this.localSwatchbook.push(items[i].id);
          }
        }
      } else {
        // Only check for saved swatches if user is logged in
        if (window.isAuthenticated) {
          window.StorageActions.getItemsFromAccount('swatch', this.onSwatchesLoaded);
        }
      }
    },
    onSwatchesLoaded: function(data) {
      this.accountSwatchData = data.swatches;
      for (var i = 0; i < data.swatches.length; i++) {
        this.localSwatchbook.push('sw-' + data.swatches[i]['swatch-id']);
      }
    },
    resetSwatchesScroll: function() {
      var element = document.getElementById('swatches-app');
      if (window.scrollY > element.offsetTop) {
        scrollToElement({
          behavior: 'instant',
          element,
        });
      }
    },
    handleScroll: function(e) {
      var swatchGrid = document.getElementById('swatch-grid');
      if (swatchGrid !== null) {
        var bounds = swatchGrid.getBoundingClientRect();
        if (bounds.bottom <= window.innerHeight) {
          this.numSwatchesToDisplay += 24;
          if (this.numSwatchesToDisplay > this.filteredByCollectionAndColorsSwatches.length) {
            this.numSwatchesToDisplay = this.filteredByCollectionAndColorsSwatches.length;
          }
        }
      }
    },
    onLineClick: function(line) {
      // If product line selected is the same as currently open, only collapse menu
      if (this.currentLineOpen !== null) {
        if (line.name === this.currentLineOpen.name) {
          line.filterOpen = !line.filterOpen;
          return;
        } else {
          // Collapse current product line product menu
          this.currentLineOpen.filterOpen = false;
        }
      }
      var that = this;
      // Load params for swatch visualizer urls before continuing
      // Open selected menu
      line.filterOpen = true;
      // Set current product line to selected
      // Uncheck any styles
      that.checkedColorRanges = [];
      that.checkedProductStyles = [];
      that.productStyles = [];
      // Set current product line to selected
      that.currentLineOpen = line;
    },
    handleUpdateAccountSwatchData: function() {
      var that = this;
      window.StorageActions.getItemsFromAccount('swatch', function(data) {
        that.accountSwatchData.splice(0, that.accountSwatchData.length);
        for (var i = 0; i < data.swatches.length; i++) {
          that.accountSwatchData.unshift(data.swatches[i]);
        }
      });
    }
  },
  watch: {
    checkedProductStyles: function() {
      vm.resetSwatchesScroll();
      // Uncheck all collection, and color range filters every time a product style filter is checked or unchecked.
      if (vm.filteredByCollectionAndColorsSwatches.length === 0) {
        vm.checkedColorRanges = [];
      }
      vm.checkedCollections = [];
      vm.numSwatchesToDisplay = 48;
    },
    checkedCollections: function() {
      vm.resetSwatchesScroll();
      // Uncheck all color range filters every time a collection filter is checked or unchecked.
      if (vm.filteredByCollectionAndColorsSwatches.length === 0) {
        vm.checkedColorRanges = [];
      }
    },
    checkedColorRanges: function() {
      vm.resetSwatchesScroll();
    }
  },
  mounted: function () {
    // Get previously saved swatches and set up the local swatchbook
    this.getSwatchesInSwatchbook();
    // Button for toggling filter content
    const filterToggle = new ToggleContentToModal({
      callbacks: {
        onOpen: () => {
          this.productFilterOpen = true;
          this.collectionFilterOpen = true;
          this.colorFilterOpen = true;
        },
        onClose: () => {
          this.productFilterOpen = true;
          this.collectionFilterOpen = true;
          this.colorFilterOpen = true;
        },
      },
      modalId: 'filter-and-sort-modal',
      toggleSelector: '.btn-filter-sort',
      toggleContent: [
        {
          content: '.product-filter-group',
          modalSelector: '#filter-and-sort-modal .product-filter-wrapper',
          defaultSelector: '#swatches-app .c-twoColumns__left',
        },
      ],
    });
    // See if the `product` parameter from the URL exists and change selected tab.
    // Determine what product line to load first based on selected tab.
    // If loading with product line number param, selectedTab is an empty string.
    // If loading page w/ no param, selectedTab will be `shades`.
    var product = this.getParameterByName('product');
    if (product !== null) {
      product = product.toLowerCase();
      // If the parameter is not a number, set the appropriate tab
      if (isNaN(product)) {
        switch (product) {
          case 'shades':
            this.selectedTab = 'shades';
            this.initialLineId = this.initialShadesLineId;
            break;
          case 'blinds':
            this.selectedTab = 'blinds';
            this.initialLineId = this.initialBlindsLineId;
            break;
          case 'drapery':
            this.selectedTab = 'drapery';
            this.initialLineId = this.initialDraperyLineId;
            break;
          default:
            this.selectedTab = 'shades';
            this.initialLineId = this.initialShadesLineId;
        }
      } else {
      // If it is a number, don't set a tab yet and load the product line by number
        this.selectedTab = '';
        this.initialLineId = parseInt(product);
        this.loadedFromParam = true;
        this.productFilterOpen = true;
      }
    }
    this.getCatalogData(this.initialLineId, this.onCatalogDataComplete);
    window.addEventListener('scroll', this.handleScroll);
  }
});
